import toast from "solid-toast"
import type { Nullable } from "../../../typescript"
import getSetEngineWeakMapFactory from "./getSetEngineWeakMapFactory"

type EngineToast = Nullable<typeof toast>

export const [getEngineToast, setEngineToast] = getSetEngineWeakMapFactory<EngineToast>()
